import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AICourseTextbook } from '@edtech-ui/core/models/ai-course/ai-courses-text-books';
import { CustomValidators } from '@edtech-ui/core/utils/course-textBook-validators';

@Component({
	selector: 'app-add-text-book-dialog-box',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule],
	templateUrl: './add-text-book-dialog-box.component.html',
	styleUrl: './add-text-book-dialog-box.component.scss'
})
export class AddTextBookDialogBoxComponent implements OnInit {

	textBookForm!: FormGroup;
	currentYear = new Date().getFullYear();

	constructor(
		@Optional() private dialogRef: MatDialogRef<AddTextBookDialogBoxComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: { textBook?: AICourseTextbook },
	) {
		{
			this.textBookForm = new FormGroup({
				title: new FormControl('', [Validators.required]),
				author: new FormControl('', [Validators.required]),
				publisher: new FormControl('', [Validators.required]),
				year: new FormControl('', [Validators.required, CustomValidators.yearRangeForCourse(1900, this.currentYear)]),
			});
		}
	}

	ngOnInit(): void {
		if (this.data && this.data.textBook && this.data.textBook) {
			this.textBookForm.patchValue({
				title: this.data.textBook.title || '',
				author: this.data.textBook.author || '',
				publisher: this.data.textBook.publisher || '',
				year: this.data.textBook.year || ''
			});
		}
	}

	closePostDialog(): void {
		this.dialogRef?.close();
	}

	saveTextBook(): void {
		if (this.textBookForm.valid) {
			this.dialogRef?.close({
				...this.data.textBook,
				...this.textBookForm.value
			});
		} else {
			this.textBookForm.markAllAsTouched();
		}
	}
}